<div>
  <div class="prose">
    <h1>Receipts</h1>
  </div>

  @if (errorFetchingInvoices || errorFetchingApiInvoices || errorFetchingDesPurchases) {
    <div class="mt-4">
      <p class="text-error">
        {{
          errorFetchingInvoices ||
            errorFetchingApiInvoices ||
            errorFetchingDesPurchases
        }}
      </p>
    </div>
  } @else if (loading) {
    <div class="mt-4 flex justify-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else {
    @if (completedInvoices.length > 0) {
      <div class="mt-8">
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                @if (hasMultipleTypes) {
                  <td class="w-28">Type</td>
                }
                <td>Order #</td>
                @if (hasApiInvoices) {
                  <td>Transaction Month</td>
                }
                <td>Total Amount</td>
                <td>Completed Date</td>
                <td class="w-36"></td>
              </tr>
            </thead>
            <tbody>
              @for (invoice of completedInvoices; track invoice) {
                <tr
                  class="cursor-pointer text-base"
                  (click)="navigateToReceipt(invoice)"
                >
                  @if (hasMultipleTypes) {
                    <td class="w-28">
                      {{ typeLabel(invoice.type) }}
                    </td>
                  }
                  <td>{{ invoice.invoice.number }}</td>
                  @if (hasApiInvoices) {
                    <td>
                      {{
                        this.getDisplayTransactionMonth(invoice)
                          | date: 'MMMM, yyyy'
                      }}
                    </td>
                  }
                  <td>{{ invoice.invoice.total_amount | currency }}</td>
                  <td>
                    {{
                      invoice.invoice.completed_at | date: 'MM/dd/yyyy, hh:mmaa'
                    }}
                  </td>
                  <td class="w-32">
                    <button class="btn btn-primary btn-sm w-32">
                      View Receipt
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Completed Invoices -->
        <div class="sm:hidden">
          @for (invoice of completedInvoices; track invoice) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
              (click)="navigateToReceipt(invoice)"
            >
              @if (hasMultipleTypes) {
                <div class="flex">
                  <p class="pb-1 pr-3 text-base-content/70">Type:</p>
                  <p>{{ typeLabel(invoice.type) }}</p>
                </div>
              }
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Order #:</p>
                <p>{{ invoice.invoice.number }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Total Amount:</p>
                <p>{{ invoice.invoice.total_amount | currency }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Completed Date:</p>
                <p>
                  {{ invoice.invoice.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="mt-8">
        <p class="italic text-base-content/80">
          No completed orders found for this account.
        </p>
      </div>
    }
  }
</div>
